<template>
    <v-dialog v-model="dialog" max-width="60%" v-resize="onResize">
        <v-card class="standard-row scroll-create-purchase-modal" style="border-radius: 10px; padding: 20px; ">
            <v-row no-gutters class="standard-row font-theme font-header-modal" style="padding-bottom: 10px;">
                <v-card-title style="font-weight: 700; font-size: 20px;" class=" set-center-document-modal">{{ getTitle() }}</v-card-title>
                <v-card-title style="font-weight: bold; font-size: 19px; margin-left: auto; " class="pr-sm-3 set-center-document-modal">Value :
                    {{ totalActual }}
                </v-card-title>
            </v-row>
            <v-card-text>
                <div v-for="(item,index) in selectedItemsFormatted" :key="index" style="font-weight:400;">
                    <v-row>
                        <v-col cols="12" sm="1" md="1" lg="1" style="font-weight:550">
                            {{ index + 1 }}
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2">
                            {{ item.sale_document }}
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2">
                            {{ item.document_id }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3">
                            {{ item.group_service }}
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2">
                            {{ item.actualFormatted }}
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2">
                            {{ item.revenueFormatted }}
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-card-actions style="justify-content: center;">
                <!-- Use v-if to conditionally show the image -->
                <v-row no-gutters class="standard-row d-flex justify-center">
                    <div class="mr-3" style="padding-top: 10px;">
                        <v-btn v-if="this.action === 'SaveCsToPo'" @click="confirmCsToPo('SaveCsToPo')" color="#0EC62B3D"
                            class="elevation-0 font-theme confirm-btn" style="width: 119px; height: 30px;">
                            <v-icon color="#008000">mdi-check-bold</v-icon>
                            <!-- <img src="../assets/icons8-check-mark-48_2.png"
                                style="margin-right:10px; width: 18px; height: 17px;"> -->
                            ยืนยัน
                        </v-btn>
                        <v-btn v-if="this.action === 'RunPo'" @click="confirmCsToPo('RunPo')" color="#0EC62B3D"
                            class="elevation-0 font-theme confirm-btn" style="width: 119px; height: 30px;">
                            <v-icon color="#008000">mdi-check-bold</v-icon>
                            <!-- <img src="../assets/icons8-check-mark-48_2.png"
                                style="margin-right:10px; width: 18px; height: 17px;"> -->
                            ยืนยัน
                        </v-btn>
                        <v-btn v-if="this.action === 'WaitQT'" @click="navigateToWaitQT" color="#0EC62B3D"
                            class="elevation-0 font-theme confirm-btn" style="width: 119px; height: 30px;">
                            <v-icon color="#008000">mdi-check-bold</v-icon>
                            <!-- <img src="../assets/icons8-check-mark-48_2.png"
                                style="margin-right:10px; width: 18px; height: 17px;"> -->
                            ยืนยัน
                        </v-btn>
                    </div>
                    <div class="mr-3" style="padding-top: 10px;">
                        <v-btn @click="closeDialog" color="#E994948C" class="elevation-0 font-theme confirm-btn"
                            style="width: 119px; height: 30px;">
                            <v-icon color="#ff0000">mdi-close-thick</v-icon>
                            <!-- <img src="../assets/icons8-wrong-48_2.png"
                                style="margin-right:10px; width: 17px; height: 22px;"> -->
                            ยกเลิก
                        </v-btn>
                    </div>
                </v-row>
            </v-card-actions>
        </v-card>
        <SaveCreateCstoPo ref="confirmSaveCreateCstoPo" />
    </v-dialog>
</template>

<script>
import { MainFunction } from '@/functions/mainFunction.js'
import { EventBus } from '../EventBus'
import SaveCreateCstoPo from './SaveCreateCstoPo.vue';
export default {
    components: {
        SaveCreateCstoPo
    },
    data() {
        return {
            windowSize: { x: 0 },
            dialog: false,
            totalActual: null,
            selectedItemsFormatted:[],
            selectedItemsConfirm: [],
            action: '',
            headers: [
                { text: 'No', value: 'number' },
                { text: 'Sale Document', value: 'sale_document' },
                { text: 'Document ID', value: 'document_id' },
                { text: 'Group Service', value: 'group_service' },
                { text: 'Actual', value: 'actual' },
                { text: 'Revenue', value: 'revenue' },
            ],
        };
    },
    mounted() {
        this.onResize()
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        open(selectedItemsConfirm, action) {
            this.selectedItemsFormatted = Object.values(selectedItemsConfirm).map(item => ({
                ...item,
                actualFormatted: MainFunction.addComma(
                    parseFloat(item.actual.replace(/,/g, '').trim()) || 0
                ),                
                revenueFormatted: MainFunction.addComma(
                    parseFloat(item.revenue.replace(/,/g, '').trim()) || 0
                )
            }));
           
            const totalActual = MainFunction.addComma(
                parseFloat(
                    Object.values(selectedItemsConfirm).reduce(
                        (sum, item) => sum + parseFloat(item.actual || 0),
                        0
                    )
                )
            );
            const totalQtValue = MainFunction.addComma(
                parseFloat(
                    Object.values(selectedItemsConfirm).reduce(
                        (sum, item) => sum + parseFloat(item.qt_value.replace(/,/g, '') || 0),
                        0
                    )
                )
            );
            this.selectedItemsConfirm = selectedItemsConfirm
            this.totalActual = totalActual;
            this.totalQtValue = totalQtValue;
            this.action = action;
            this.dialog = true;

        },
        getTitle() {
            if (this.action === 'SaveCsToPo') {
                return 'บันทึกข้อมูล';
            } else if (this.action === 'RunPo') {
                return 'RUN PO';
            } else {
                return 'Wait QT';
            }
        },
        navigateToWaitQT() {
            // Navigate to the '/create_wait_qt' path
            this.$router.push({ path: '/create_cs_wait_qt' });
        },
        closeDialog() {
            // ทำสิ่งที่คุณต้องการเมื่อ Confirm Dialog ถูกปิด
            // console.log('Confirm Dialog closed!');
            this.dialog = false;
            // อาจจะเรียก method หรือทำอื่นๆ ที่คุณต้องการ
        },
        async confirmCsToPo(action) {
            this.action = action;
            var cs_id_arr = []
            var body = {}
            this.selectedItemsConfirm.forEach((el) => {
                // console.log(el._id);
                body = {
                    _id: el._id,
                    qt_vendor: el.qt_vendor || "",
                    qt_value: el.qt_value.replace(/,/g, '') || "",
                    vendor_id: el.vendor._id || "",
                    is_multi_qt: el.is_multi_qt ?? false,
                    discount: el.discount.replace(/,/g, '') || "",
                    terminate: el.terminate || "",
                    terminate_date: el.terminate_date || "",
                    status_terminate: el.status_terminate || "",
                }
                cs_id_arr.push(body)
            })
            // const csList = Object.values(this.selectedItemsConfirm).map(item => ({
            //     "sale_document": item.sale_document || "",
            //     "document_id": item.document_id || "",
            //     "job_status": item.job_status || "",
            //     "group_service": item.group_service || "",
            //     "service_name": item.service_name || "",
            //     "actual": item.actual || "",
            //     "revenue": item.revenue || "",
            //     "qt_vendor": item.qt_vendor || "",
            //     "qt_value": item.qt_value || "",
            //     "from_doc" : "cs_po"
            // }));
            // const requestBody = {
            //     "cs_list": csList
            // };
            const requestBody = {
                "cs_list" : cs_id_arr
            }
            this.$refs.confirmSaveCreateCstoPo.open(action, this.selectedItemsConfirm, requestBody, this.totalActual,this.totalQtValue);
            this.dialog = false
        }
    },
}
</script>
<style>
    .scroll-create-purchase-modal {
        max-height: calc(100vh - 254px);
        min-height: 254px !important;
        overflow-y: auto;
        border-radius: 20px !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar {
        width: 12px;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar {
        width: 8px;
        background-color: transparent !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #D9D9D9;
    }

    @media only screen and (max-width: 600px) {
        
        .set-center-document-modal {
            text-align: center;
        }
    }
</style>